// Local Storage Service for Resume Builder
class LocalStorageService {
  constructor() {
    this.USER_DATA_KEY = 'resumeBuilder_userData';
    this.RESUME_DRAFT_KEY = 'resumeBuilder_resumeDraft';
  }

  // User Data Methods
  saveUserData(userData) {
    try {
      const dataToSave = {
        name: userData.name,
        email: userData.email,
        savedAt: new Date().toISOString()
      };
      localStorage.setItem(this.USER_DATA_KEY, JSON.stringify(dataToSave));
      return true;
    } catch (error) {
      console.error('Failed to save user data to localStorage:', error);
      return false;
    }
  }

  getUserData() {
    try {
      const data = localStorage.getItem(this.USER_DATA_KEY);
      console.log("DATAAA", this.USER_DATA_KEY)
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Failed to retrieve user data from localStorage:', error);
      return null;
    }
  }

  clearUserData() {
    try {
      localStorage.removeItem(this.USER_DATA_KEY);
      return true;
    } catch (error) {
      console.error('Failed to clear user data from localStorage:', error);
      return false;
    }
  }

  hasUserData() {
    const userData = this.getUserData();
    return userData && userData.name && userData.email;
  }

  // Resume Draft Methods (for future use)
  saveResumeDraft(resumeData) {
    try {
      const dataToSave = {
        ...resumeData,
        savedAt: new Date().toISOString()
      };
      localStorage.setItem(this.RESUME_DRAFT_KEY, JSON.stringify(dataToSave));
      return true;
    } catch (error) {
      console.error('Failed to save resume draft to localStorage:', error);
      return false;
    }
  }

  getResumeDraft() {
    try {
      const data = localStorage.getItem(this.RESUME_DRAFT_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Failed to retrieve resume draft from localStorage:', error);
      return null;
    }
  }

  clearResumeDraft() {
    try {
      localStorage.removeItem(this.RESUME_DRAFT_KEY);
      return true;
    } catch (error) {
      console.error('Failed to clear resume draft from localStorage:', error);
      return false;
    }
  }

  // Utility Methods
  clearAllData() {
    try {
      this.clearUserData();
      this.clearResumeDraft();
      return true;
    } catch (error) {
      console.error('Failed to clear all data from localStorage:', error);
      return false;
    }
  }

  getStorageInfo() {
    return {
      hasUserData: this.hasUserData(),
      userData: this.getUserData(),
      hasResumeDraft: !!this.getResumeDraft(),
      storageUsed: this.calculateStorageUsed()
    };
  }

  calculateStorageUsed() {
    try {
      let total = 0;
      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key) && key.startsWith('resumeBuilder_')) {
          total += localStorage[key].length;
        }
      }
      return `${(total / 1024).toFixed(2)} KB`;
    } catch (error) {
      return 'Unknown';
    }
  }
}

export default new LocalStorageService();
